const additionalPrice = [
    'Cena netto',
    'Do negocjacji',
    'Faktura VAT',
    'Możliwość leasingu',
    'VAT marża',
    'Możliwość finansowania',
    'Ogłoszenie prywatne',
    'Ogłoszenie firmowe',
    'Ogłoszenie autoryzowanego dealera',
    'Cesja',
]

export const additionalPriceNames = [
    'cena-netto',
    'do-negocjacji',
    'faktura-vat',
    'leasing',
    'vat-marza',
    'finansowanie',
    'ogloszenie-prywatne',
    'ogloszenie-firmowe',
    'autoryzowany-dealer',
    'cesja',
]

export const additionalPriceAlt = [
    'Cena netto',
    'Do negocjacji',
    'Faktura VAT',
    'Możliwość leasingu',
    'VAT marża',
    'Możliwość finansowania',
    'Cesja',
]

export const additionalPriceNamesAlt = [
    'cena-netto',
    'do-negocjacji',
    'faktura-vat',
    'leasing',
    'vat-marza',
    'finansowanie',
    'cesja',
]

export default additionalPrice